import isString from 'lodash-es/isString';
export const toTitleCase = (text: string) => {
  if (!isString(text) || text === '') return text;
  if (text.length === 1) return text.charAt(0).toUpperCase();
  return text.charAt(0).toUpperCase() + text.substring(1);
};
